import { render, staticRenderFns } from "./NCCampaignDetail.vue?vue&type=template&id=992ba83e"
import script from "./NCCampaignDetail.vue?vue&type=script&lang=js"
export * from "./NCCampaignDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports